/**
 *
 * Asynchronously loads the JIT container
 *
 */

import { lazy } from 'react';

export const Jit = lazy(() =>
  import('./index').then(module => ({ default: module.Jit })),
);
